import { QueryClient } from '@tanstack/react-query'
import { ApiError } from './api'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 3, // 3 minutes
      retry: (failureCount, error) => {
        // Don't retry auth errors
        if (error instanceof ApiError && [401, 403].includes(error.status)) return false
        return failureCount < 2
      },
      refetchOnWindowFocus: false,
    },
    mutations: {
      onError: (error) => {
        if (error instanceof ApiError && error.status === 401) {
          // Session expired — redirect to login
          window.location.href = '/auth/login'
        }
      },
    },
  },
})
